exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th.sortable{position:relative;cursor:pointer}th.sortable>i.sort-icon{position:absolute;right:18px;top:18px;color:#aaa}th.sortable:hover,th.sortable:hover>i.sort-icon,th.sortable>i.sort-icon.fa-sort-asc,th.sortable>i.sort-icon.fa-sort-desc{color:#673ab7}", ""]);

// exports
